import React, { useState } from 'react';
import styled from 'styled-components';
import { Input, Select, Row, Col, Button, Typography, Space } from 'antd';
import { SearchOutlined, FilterOutlined, ClearOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Text } = Typography;

const TemplatePageSearch = ({ onSearch, onFilterChange }) => {
  const [searchText, setSearchText] = useState('');
  const [analysisLevel, setAnalysisLevel] = useState(undefined);
  const [scope, setScope] = useState(undefined);
  const [isActive, setIsActive] = useState(undefined);
  const [category, setCategory] = useState(undefined);

  const handleSearch = () => {
    const filters = {
      searchText: searchText || undefined,
      analysisLevel: analysisLevel || undefined,
      scope: scope || undefined,
      isActive: isActive !== undefined ? isActive : undefined,
      category: category || undefined,
    };

    onSearch?.(filters);
    onFilterChange?.(filters);
  };

  const handleClear = () => {
    setSearchText('');
    setAnalysisLevel(undefined);
    setScope(undefined);
    setIsActive(undefined);
    setCategory(undefined);

    onSearch?.({});
    onFilterChange?.({});
  };

  return (
    <SearchContainer>
      <Row gutter={[12, 12]} align="middle">
        <Col span={8}>
          <SearchSection>
            <CompactSearch
              placeholder="Search templates..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={handleSearch}
              prefix={<SearchOutlined style={{ color: 'var(--aura-navy)' }} />}
              allowClear
            />
          </SearchSection>
        </Col>

        <Col span={3}>
          <CompactSelect
            placeholder="Level"
            value={analysisLevel}
            onChange={setAnalysisLevel}
            allowClear
          >
            <Select.Option value="page">Page</Select.Option>
            <Select.Option value="module">Module</Select.Option>
            <Select.Option value="dashboard">Dashboard</Select.Option>
            <Select.Option value="executive">Executive</Select.Option>
          </CompactSelect>
        </Col>

        <Col span={3}>
          <CompactSelect
            placeholder="Scope"
            value={scope}
            onChange={setScope}
            allowClear
          >
            <Select.Option value="SYSTEM">System</Select.Option>
            <Select.Option value="ORGANIZATION">Org</Select.Option>
            <Select.Option value="USER">User</Select.Option>
          </CompactSelect>
        </Col>

        <Col span={3}>
          <CompactSelect
            placeholder="Status"
            value={isActive}
            onChange={setIsActive}
            allowClear
          >
            <Select.Option value={true}>Active</Select.Option>
            <Select.Option value={false}>Inactive</Select.Option>
          </CompactSelect>
        </Col>

        <Col span={3}>
          <CompactInput
            placeholder="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            allowClear
          />
        </Col>

        <Col span={4}>
          <ActionsRow>
            <Button 
              type="text" 
              icon={<ClearOutlined />} 
              onClick={handleClear}
              style={{ color: 'var(--aura-slate)', fontSize: 11, height: 32 }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={handleSearch}
              style={{ 
                background: 'var(--aura-blue)', 
                borderRadius: '6px',
                height: '32px',
                fontSize: 11,
                fontWeight: 700
              }}
            >
              Filter
            </Button>
          </ActionsRow>
        </Col>
      </Row>
    </SearchContainer>
  );
};

const SearchContainer = styled.div`
  background: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f5f9;
  margin-bottom: 16px;
`;

const SearchSection = styled.div`
  position: relative;
`;

const CompactSearch = styled(Search)`
  .ant-input-wrapper {
    display: flex;
  }
  
  .ant-input-affix-wrapper {
    background: #f8fafc;
    border-radius: 6px 0 0 6px !important;
    border: 1px solid #e2e8f0;
    height: 32px;
    
    &:hover, &:focus-within {
      border-color: var(--aura-navy);
    }
  }

  .ant-input {
    background: transparent !important;
    font-size: 13px !important;
  }

  .ant-input-group-addon {
    button {
      height: 32px !important;
      border-radius: 0 6px 6px 0 !important;
      background: var(--aura-blue) !important;
      border-color: var(--aura-blue) !important;
      
      &:hover {
        background: #0284c7 !important;
        border-color: #0284c7 !important;
      }
    }
  }
`;

const CompactSelect = styled(Select)`
  width: 100%;
  
  .ant-select-selector {
    background: #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 6px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    font-size: 13px !important;
    
    &:hover {
      border-color: var(--aura-navy) !important;
    }
  }
`;

const CompactInput = styled(Input)`
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  height: 32px !important;
  font-size: 13px !important;
  
  &:hover, &:focus {
    border-color: var(--aura-navy) !important;
  }
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
`;

export default TemplatePageSearch;

